var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSdk = function SvgSdk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.512 3a2.49 2.49 0 0 1 2.483 2.331l.005.157v11.268a2.49 2.49 0 0 1-2.331 2.483l-.157.005H3.488a2.49 2.49 0 0 1-2.483-2.33L1 16.755V5.488a2.49 2.49 0 0 1 2.33-2.483L3.489 3h15.024zm0 1.22H3.488a1.27 1.27 0 0 0-1.261 1.146l-.006.122v11.268c0 .658.503 1.2 1.145 1.262l.122.005h15.024c.658 0 1.2-.503 1.261-1.145l.006-.122V5.488c0-.7-.568-1.267-1.267-1.267zm-1.878 10.048a.61.61 0 0 1 .096 1.213l-.096.007H11a.61.61 0 0 1-.09-1.214l.09-.006h5.634zM5.72 6.87l.076.062 3.758 3.758a.61.61 0 0 1 .062.79l-.062.073-3.758 3.757a.61.61 0 0 1-.924-.788l.063-.077 3.323-3.324-3.325-3.326a.61.61 0 0 1-.106-.7l.05-.08.063-.076a.61.61 0 0 1 .78-.07z"
  })));
};

export default SvgSdk;